// extracted by mini-css-extract-plugin
export default {"value":"ViewField_value__qPM4y","textarea":"ViewField_textarea__ics10"};